import React from 'react'
import { Router, Route, Switch } from 'react-router-dom'

import App from './containers/App'
import Login from './containers/Login'
import roles from './constants/Roles'

// Dashboard
import Dashboard from './containers/dashboard/Dashboard'

// jobs
import Jobs from './containers/job/jobs'
import JobView from './containers/job/jobView'

// items
import Items from './containers/items/'

// leads
import Leads from './pages/leads'
import LeadMain from './pages/lead'

// companies
import Companies from './containers/companies/'

// vendors
import Vendors from './containers/vendors/'

// contacts
import Contacts from './containers/contacts/'

// employees
import Employees from './containers/employees/'

// tasks
import Tasks from './containers/tasks/'

// help
import Help from './containers/help/'

// drivers
import Drivers from './containers/drivers/'

// vehicles
import Vehicles from './containers/vehicles/Vehicles'

// user actions
import Users from './containers/users/'
import Account from './containers/Account'

// templates e forms
import Templates from './containers/templates/'
import TemplatesEstimate from './containers/templates/estimateTemplate'
import TemplatesProposal from './containers/templates/proposalTemplate'
import TemplatesContract from './containers/templates/contractTemplate'
import TemplatesMaterialRequest from './containers/templates/materialRequestTemplate'
import TemplatesWorkOrder from './containers/templates/workOrderTemplate'
import TemplatesJobMinute from './containers/templates/jobMinuteTemplate'
import TemplatesDriverRequest from './containers/templates/driverRequestTemplate'
import TemplatesRepairOrder from './containers/templates/repairOrderTemplate'
import TemplatesServiceOrder from './containers/templates/serviceOrderTemplate'
import TemplatesContactGroup from './containers/templates/contactGroupTemplate'
import TemplatesChangeOrder from './containers/templates/changeOrderTemplate'
import TemplatesForm from './containers/templates/formTemplate'

// templates e forms
import AdminApp from './containers/AdminApp'
import EnsureAuthenticated from './containers/EnsureAuthenticated'
import PrivateRoute from './containers/PrivateRoute'

import NoMatch from './components/NoMatch'

import history from './history'
import ReportsContainer from './containers/reports/ReportsContainer'

export default () => (
  <Router history={history}>
    <App>
      <Switch>
        <Route path="/login" component={Login} exact />
        <Route path="/" component={Login} exact />

        {/* private routes using admin app layout */}
        <PrivateRoute allowedRoles={[roles.ADMIN]} path="/users" component={Users} />
        <PrivateRoute
          allowedRoles={[roles.ADMIN, roles.CONTROLLER_1]}
          path="/employees"
          component={Employees}
        />

        <EnsureAuthenticated>
          <AdminApp>
            {/* Dashboard */}
            <Route path="/dashboard" component={Dashboard} />

            {/* jobs */}
            <Route path="/jobs" component={Jobs} exact />
            <Route path="/jobs/:parentJobId" component={Jobs} exact />
            <Route path="/jobView/:jobId/:jobType" component={props => <JobView {...props} />} />

            {/* items */}
            <Route path="/items" component={props => <Items {...props} />} exact />

            {/* leads */}
            <Route path="/leads" component={Leads} exact />
            <Route path="/lead/:leadId" component={props => <LeadMain {...props} />} />

            {/* companies */}
            <Route path="/companies" component={Companies} exact />
            <Route path="/companies/:companyId" component={Companies} exact />

            {/* vendors */}
            <Route path="/vendors" component={Vendors} exact />
            <Route path="/vendors/:vendorId" component={Vendors} exact />

            {/* contacts */}
            <Route path="/contacts/:contactId" component={props => <Contacts {...props} />} />
            <Route path="/contacts" component={Contacts} exact />

            {/* employees */}

            {/* tasks */}
            <Route path="/tasks" component={Tasks} exact />

            {/* drivers */}
            <Route path="/drivers" component={Drivers} />

            {/* vehicles */}
            <Route path="/vehicles" component={Vehicles} />

            {/* user actions */}
            <Route path="/account" component={Account} />

            {/* templates */}
            <Route path="/templates/:templateType" component={Templates} exact />
            <Route
              path="/templates/estimate/:templateId"
              component={props => <TemplatesEstimate {...props} />}
              exact
            />
            <Route path="/templates/proposal/:templateId" component={TemplatesProposal} exact />
            <Route path="/templates/contract/:templateId" component={TemplatesContract} exact />
            <Route
              path="/templates/material_request/:templateId"
              component={TemplatesMaterialRequest}
              exact
            />
            <Route path="/templates/work_order/:templateId" component={TemplatesWorkOrder} exact />
            <Route path="/templates/job_minute/:templateId" component={TemplatesJobMinute} exact />
            <Route
              path="/templates/driver_request/:templateId"
              component={TemplatesDriverRequest}
              exact
            />
            <Route
              path="/templates/repair_order/:templateId"
              component={TemplatesRepairOrder}
              exact
            />
            <Route
              path="/templates/service_order/:templateId"
              component={TemplatesServiceOrder}
              exact
            />
            <Route
              path="/templates/contact_group/:templateId"
              component={TemplatesContactGroup}
              exact
            />
            <Route
              path="/templates/change_order/:templateId"
              component={TemplatesChangeOrder}
              exact
            />
            <Route path="/templates/form/:templateId" component={TemplatesForm} exact />

            {/* Reports */}
            <Route path="/reports" component={ReportsContainer} />

            {/* help */}
            <Route path="/help" component={Help} exact />
          </AdminApp>
        </EnsureAuthenticated>
        <Route component={NoMatch} />
      </Switch>
    </App>
  </Router>
)



// WEBPACK FOOTER //
// ./src/routes.js